import React from 'react';
import { EditorContentFormDevicePreviewToggles } from 'src/editor/content-form/device-preview-toggles';
import { useStepEditorContext } from 'src/store/step-editor';

export const StepEditorPreviewDeviceToggles = () => {
  const { isMobilePreview, setIsMobilePreview } = useStepEditorContext();
  return (
    <div className='flex justify-end p-0 relative w-full min-w-0'>
      <EditorContentFormDevicePreviewToggles
        isMobilePreview={isMobilePreview}
        onToggleChange={({ isMobilePreview }) => {
          setIsMobilePreview(isMobilePreview);
        }}
      />
    </div>
  );
};
